export class Package {
  constructor(
    technical_id,
    boomerang_id,
    package_type,
    client_price,
    network_code,
    display_estimate
  ) {
    this.technical_id = technical_id
    this.boomerang_id = boomerang_id
    this.package_type = package_type
    this.client_price = client_price
    this.network_code = network_code
    this.display_estimate = display_estimate
  }
}
